import ERPImage from "./assets/images/ERP_Image.png";
import AIERP from "./assets/images/ERP_AI.png";

const logotext = "AMANPREET";
    const meta = {
        title: "Amanpreet Ahluwalia",
        description: "Applied AI Engineer specialising in automation, anomaly detection and decision-support systems for enterprise, ERP, finance and operational platforms..",
    };

    const introdata = {
        title: "I’m Amanpreet Ahluwalia",
        animated: {
            first: "Senior NetSuite Consultant",
            second: "Enterprise AI & Automation Engineer",
            third: "AI for ERP, Finance & Operations",
        },
        description: "Applied AI Engineer with 7+ years of experience working in enterprise ERP, finance and operational systems. I build production-ready AI, automation and monitoring solutions focused on reliability, decision support and real-world business impact.",
        your_img_url: "https://raw.githubusercontent.com/AmanpreetSingh0071/Aman_portfolio/main/Firefly%20Design%20a%20professional%20LinkedIn%20banner%20for%20an%20AI%20Engineer._Background-%20Dark%20navy%20blue%20to%20deep.JPEG"
    };

    const dataabout = {
        title: "About Me",
        aboutme: "Enterprise systems and ERP consultant with hands-on experience delivering integrations, automation and operational solutions across complex business environments. I use data-driven and intelligent techniques where they add practical value, focusing on reliability, scalability and long-term system efficiency rather than experimentation.",
    };

    const worktimeline = [
        {
            jobtitle: "AI FullStack Developer",
            where: "GBCS Group",
            date: "June 2025 - Mar 2026",
        },
        {
            jobtitle: "AI/ML Engineer",
            where: "3NS.AI, London",
            date: "Feb 2025 - May 2025",
        },
        {
            jobtitle: "IT Specialist",
            where: "Bristlecone India Ltd. (Mahindra Group)",
            date: "Aug 2019 - Oct 2024",
        },
    ];

    const skills = [
    { name: "NetSuite & ERP Systems", value: 85 },
    { name: "EDI & System Integrations", value: 85 },
    { name: "Python & AI Automation", value: 85 },
    { name: "LangChain & LLM Systems", value: 85 },
    { name: "SuiteScript & SuiteFlow", value: 85 },
    { name: "Data Analysis & Reporting", value: 85 },
    { name: "Cloud & DevOps (Azure, Docker)", value: 85 },
];

    const services = [
    {
        title: "NetSuite Implementation & Integration",
        description: "End-to-end NetSuite delivery across O2C, P2P and supply chain — specialising in high-volume EDI, 3PL and WMS integrations via SPS Commerce and Celigo iPaaS across manufacturing, healthcare and retail.",
    },
    {
        title: "AI-Powered ERP Automation",
        description: "Building intelligent automation on top of ERP systems. LLM-driven document intelligence, anomaly detection, RAG pipelines and proactive monitoring that reduce manual effort and surface failures before business impact.",
    },
    {
        title: "Enterprise Systems & Workflow Automation",
        description: "SuiteScript 2.x customisation, SuiteFlow workflows and REST/SOAP integrations that automate complex business processes across finance, fulfilment and operations — from exception handling to auto-invoicing.",
    },
];

    const dataportfolio = [
        {
            img: AIERP,
            description: "AI - ERP Exception Monitoring System – Intelligent monitoring for ERP integrations using LLMs and RAG to proactively investigate failures, SLA breaches and abnormal transaction behaviour.",
            link: "https://erp-ai-monitor.vercel.app",
        },
        {
            img: ERPImage,
            description: "ERP Exception Monitoring System – Intelligent monitoring for ERP integrations using rule-based validation and anomaly detection to proactively identify failures, SLA breaches and abnormal transaction behaviour.",
            link: "#/projects/erp-exception-monitoring",
        },
        {
            img: "https://github.com/AmanpreetSingh0071/Aman_portfolio/blob/main/8ce97337-b164-4190-9c04-b9f9fd2633c7.png?raw=true", // Replace with an actual screenshot URL
            description: "PDF Data Extraction using AI - Automated structured data extraction reducing manual effort by 60%.",
            link: "https://chat-with-your-pdfs-aman-007.streamlit.app/",
        },
        {
            img: "https://github.com/AmanpreetSingh0071/Aman_portfolio/blob/main/7F564148-A919-421D-BC53-7DACF82C2427.png?raw=true", // Replace with an actual screenshot URL
            description: "AI Coach and Memoir Co-Writer.",
            link: "https://aimemoir.streamlit.app/",
        },
        {
            img: "https://github.com/AmanpreetSingh0071/Aman_portfolio/blob/main/8785DC46-090E-4614-985B-6F60A02B6770.png?raw=true", // Replace with an actual screenshot URL
            description: "AI-Job-Search-Tool.",
            link: "https://autoapplyx-aman-007.streamlit.app/",
        },
        {
            img: "https://github.com/AmanpreetSingh0071/Aman_portfolio/blob/main/ChatGPT%20Image%20Mar%2026%2C%202025%2C%2008_00_30%20PM.png?raw=true", // Replace with an actual screenshot URL
            description: "AI-Powered Audit Report Generator for Businesses.",
            link: "https://audit-report-generator-aman-007.streamlit.app/",
        },
        {
            img: "https://github.com/AmanpreetSingh0071/Aman_portfolio/blob/main/ChatGPT%20Image%20Mar%2026%2C%202025%2C%2003_35_18%20PM.png?raw=true", // Replace with an actual screenshot URL
            description: "Weather Forecasting Model - Built an ML model predicting weather patterns.",
            link: "https://predict-energy-aman-007.streamlit.app/",
        },
        {   
            img: "https://github.com/AmanpreetSingh0071/Aman_portfolio/blob/main/ChatGPT%20Image%20Mar%2026%2C%202025%2C%2003_37_12%20PM.png?raw=true", // Replace with an actual screenshot URL
            description: "AI Dashboard App - An interactive Streamlit app for data visualisation and AI model insights.",
            link: "https://ipredictionpremium-aman007.streamlit.app/", // Replace with your Streamlit app URL
        },
        {
            embed: "https://www.youtube.com/embed/7SVjK-2S-iE?si=aS_T6ovORD1vYZog",
            description: "Autonomous Vehicle Simulation - Implemented real-time obstacle avoidance using AI sensors.",
        },
        {
            embed: "https://www.youtube.com/embed/4qVD9D7ftjs?si=DlSBM8bLoshV_6dO",
            description: "Disease Simulation in Netlogo.",
        },
    ];
    
    const contactConfig = {
        YOUR_EMAIL: "work.amanpreet.singh@gmail.com",
        YOUR_FONE: "+44 7823705602",
        description: "Open to Applied AI and enterprise automation roles, consulting engagements and collaboration on production-grade AI systems",
        YOUR_SERVICE_ID: "service_5r6vlo8",
        YOUR_TEMPLATE_ID: "template_6wqnwym",
        YOUR_USER_ID: "tI3lYbIH_OBPuAiJ7",
    };

    const socialprofils = {
        resume: "https://github.com/AmanpreetSingh0071/Public_Resume/raw/main/Amanpreet_M_Ahluwalia_CV.pdf", // Added Resume Download Link
        github: "https://github.com/AmanpreetSingh0071",
        linkedin: "https://linkedin.com/in/aman-m-singh",
        twitter: "https://x.com/AmanpreetA007",
    };

    export {
        meta,
        dataabout,
        dataportfolio,
        worktimeline,
        skills,
        services,
        introdata,
        contactConfig,
        socialprofils,
        logotext,
    };